import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["portalId", "authenticatorId", "mcpServerId", "appName", "oAuthScope", "appId", "mcp", "onComplete", "onCancel", "shouldDeleteOnFailure", "introScreen", "successScreen"];
import { useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { MCPAuthModal } from './MCPAuthModal';
import { deleteSecret } from './Api';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
const noop = () => {};
export const MCPAuthButton = _ref => {
  let {
      portalId,
      authenticatorId,
      mcpServerId,
      appName,
      oAuthScope,
      appId,
      mcp,
      onComplete,
      onCancel = noop,
      shouldDeleteOnFailure,
      introScreen,
      successScreen
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [showAuthModal, setShowAuthModal] = useState(false);
  function closeModal() {
    setShowAuthModal(false);
  }
  function onCompleteHandler(secretId) {
    let onCompleteSucceeded = false;
    try {
      onComplete(secretId);
      onCompleteSucceeded = true;
    } catch (error) {
      const shouldCleanup = shouldDeleteOnFailure ? shouldDeleteOnFailure(secretId) : true;
      if (shouldCleanup) {
        // This is intentionally fire and forget.
        void deleteSecret(portalId, authenticatorId, secretId);
      }
      throw error;
    } finally {
      // Auto-close modal only if no custom success screen is provided
      if (onCompleteSucceeded && !successScreen) {
        closeModal();
      }
    }
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, Object.assign({}, props, {
      onClick: clickEvent => {
        setShowAuthModal(true);
        if (props.onClick) {
          props.onClick(clickEvent);
        }
      }
    })), showAuthModal && /*#__PURE__*/_jsx(MCPAuthModal, {
      portalId: portalId,
      authenticatorId: authenticatorId,
      mcpServerId: mcpServerId,
      appName: appName,
      closeModal: closeModal,
      onCancel: onCancel,
      onComplete: onCompleteHandler,
      introScreen: introScreen,
      successScreen: successScreen,
      oAuthScope: oAuthScope,
      appId: appId,
      mcp: mcp
    })]
  });
};